// env dependent config goes here

(function() {
	if (typeof(window.PM) === 'undefined') {
		window.PM = {};
	}
})();
